import React from "react";
import { Typography, Card, Row, Col } from "antd";
import { IndianRupee, Home, Warehouse, Tent, Building2 } from "lucide-react";

const { Title, Paragraph } = Typography;

const RentalIncome = () => {
  const rentalOptions = [
    {
      title: "Farmhouse Rental",
      icon: <Home size={40} />,
      description:
        "Build a luxurious farmhouse and rent it out for weekend getaways, events, or long-term stays. High-end farmhouses can generate significant rental income.",
      potential: "₹30,000 - ₹50,000 per weekend",
    },
    {
      title: "Agricultural Storage",
      icon: <Warehouse size={40} />,
      description:
        "Construct storage facilities for agricultural products. Local farmers often need storage space for their produce, creating a steady rental income stream.",
      potential: "₹15,000 - ₹25,000 per month",
    },
    {
      title: "Event Space",
      icon: <Tent size={40} />,
      description:
        "Develop your plot into an event space for weddings, corporate retreats, or social gatherings. The natural setting makes it perfect for outdoor events.",
      potential: "₹50,000 - ₹1,00,000 per event",
    },
    {
      title: "Commercial Development",
      icon: <Building2 size={40} />,
      description:
        "Build small commercial spaces like restaurants, cafes, or shops to cater to visitors and locals, generating regular rental income.",
      potential: "₹20,000 - ₹40,000 per month",
    },
  ];

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="text-center mb-12">
        <Title level={1}>Rental Income Opportunities</Title>
        <Paragraph className="text-lg max-w-3xl mx-auto text-gray-600 mt-4">
          Transform your plot investment into a lucrative rental income source.
          Our strategically located plots offer multiple opportunities for
          generating steady rental income through various development options.
        </Paragraph>
      </div>

      <Row gutter={[24, 24]} className="mb-16">
        {rentalOptions.map((option, index) => (
          <Col xs={24} sm={12} lg={6} key={index}>
            <Card
              className="h-full hover:shadow-lg transition-shadow duration-300"
              style={{ textAlign: "center", height: "100%" }}
            >
              <div className="flex justify-center mb-6 text-blue-600">
                {option.icon}
              </div>
              <Title level={4} className="mb-4">
                {option.title}
              </Title>
              <Paragraph className="mb-4 text-gray-600">
                {option.description}
              </Paragraph>
              <div className="mt-auto">
                <div className="flex items-center justify-center gap-2 text-green-600 font-semibold">
                  <IndianRupee size={18} />
                  <span>Potential Income:</span>
                </div>
                <div className="text-green-600 font-bold mt-1">
                  {option.potential}
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="bg-gray-50 rounded-xl p-8 mb-16">
        <Title level={2} className="mb-6">
          Why Choose Our Plots for Rental Income?
        </Title>
        <Row gutter={[24, 24]}>
          <Col xs={24} md={8}>
            <Title level={4}>Strategic Location</Title>
            <Paragraph>
              Located in a prime area with excellent connectivity, making it
              attractive for various rental purposes.
            </Paragraph>
          </Col>
          <Col xs={24} md={8}>
            <Title level={4}>Development Freedom</Title>
            <Paragraph>
              Flexibility to develop your plot according to market demand and
              maximize rental potential.
            </Paragraph>
          </Col>
          <Col xs={24} md={8}>
            <Title level={4}>Growing Market</Title>
            <Paragraph>
              Rising demand for recreational spaces and weekend getaways ensures
              good rental prospects.
            </Paragraph>
          </Col>
        </Row>
      </div>

      <div className="text-center">
        <Title level={2} className="mb-6">
          Start Your Rental Journey
        </Title>
        <Paragraph className="text-lg max-w-3xl mx-auto">
          Our team can help you plan and develop your plot for maximum rental
          income potential. Contact us for personalized guidance on making the
          most of your investment.
        </Paragraph>
      </div>
    </div>
  );
};

export default RentalIncome;
